var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4"},[_c('h3',{staticClass:"text-5 text-center mt-5 mb-3"},[_vm._v("Payout Request Confirmation")]),_vm._v(" "),_c('check-mark',{staticClass:"p-6"}),_vm._v(" "),_c('p',{staticClass:"text-center text-4 mb-5"},[_vm._v("Your payout request was successful we have debited your wallet")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }